var React = require('react');

function Trash12x12 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Size=12x12","clipPath":"url(#clip0_11770_380931)","stroke":"#676767","key":0},[React.createElement("path",{"id":"Vector 235","d":"M0 3h4m8 0H8M4 3V.5h4V3M4 3h4","strokeWidth":"2","key":0}),React.createElement("path",{"id":"Vector 236","d":"M10 3H2v7.5a.5.5 0 00.5.5h7a.5.5 0 00.5-.5V3z","strokeWidth":"2","key":1}),React.createElement("path",{"id":"Vector 237","d":"M4.5 5.5l3 3","key":2}),React.createElement("path",{"id":"Vector 238","d":"M7.5 5.5l-3 3","key":3})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_11770_380931"},React.createElement("path",{"fill":"#fff","d":"M0 0h12v12H0z"})))]);
}

Trash12x12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Trash12x12;

Trash12x12.default = Trash12x12;
